import { upperAllFirstCharacterOfString } from '@lfg/core/lib';
import { Chip, ChipProps, Typography, alpha } from '@mui/material';

interface StatusState {
  color: string;
  bgColor: string;
}

export interface StatusChipProps extends Omit<ChipProps, 'value'> {
  type: keyof typeof STATUS_STATE;
  value: string;
}

const StatusChip = ({ type, value, sx, ...rest }: StatusChipProps) => {
  if (!value) return null;
  return (
    <Chip
      label={
        <Typography className='text-head_xs font-gotham' color={STATUS_STATE[type].color}>
          {upperAllFirstCharacterOfString(value)}
        </Typography>
      }
      sx={{
        borderRadius: '4px',
        backgroundColor: STATUS_STATE[type].bgColor,
        width: 'fit-content',
        ...sx,
      }}
      {...rest}
    />
  );
};

const STATUS_STATE: Record<string, StatusState> = {
  success: {
    color: '#17A975',
    bgColor: alpha('#17A975', 0.06),
  },
  normal: {
    color: '#FFFFFF',
    bgColor: alpha('#FFFFFF', 0.06),
  },
} as const;

export { StatusChip };
